import React, { MouseEvent, MouseEventHandler } from "react";
import * as icons from "./icons/icons.jsx";
import * as s from "./SVGIcon.module.css";
import classNames from "classnames";

/***
 * # TYPE DEFINITIONS @ bottom of file
 ***/

export default function SVGIcon({
    icon,
    color,
    className = "",
    onClick,
    hoverAnimation,
}: {
    icon: (typeof SVGIconTypes)[number];
    color?: (typeof SVGIconColors)[number];
    className?: string;
    onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
    hoverAnimation?: (typeof SVGIconHoverAnimations)[number];
}) {
    if (icon === null || undefined) return;
    const transformColorsToClassNames = (color: (typeof SVGIconColors)[number]) => {
        if (!color) return;
        if (color === "black") return "black";
        if (!!color.includes("-")) return color.replaceAll("-", "_");

    }

    const transformedColor: string | null | undefined = color
        ? transformColorsToClassNames(color)
        : null;

    const rootClasses = classNames(s.root, {
        [s[transformedColor]]: transformedColor,
        [className]: !!className,
        [s["transform"]]: !!hoverAnimation,
        [s[hoverAnimation]]: !!hoverAnimation,
    });

    return (
        <span onClick={onClick} className={rootClasses}>
            {icons[icon]()}
        </span>
    );
}

export const SVGIconTypes = [
    "map",
    "list",
    "close",
    "search",
    "chevron",
    "burgundyorangeclose",
    "globe",
    "roundArrow",
    "chevronGradient",
] as const;

export const SVGIconColors = [
    null,
    "black",
    "--neutral-greyscale-100",
    "--neutral-greyscale-200",
    "--neutral-greyscale-300",
    "--neutral-greyscale-400",
    "--neutral-greyscale-500",
    "--neutral-greyscale-600",
    "--neutral-greyscale-700",
    "--petroleum-500",
    "--petroleum-400",
    "--petroleum-200",
    "--petroleum-100",
    "--petroleum-50",
    "--burgundy-500",
    "--burgundy-100",
    "--secondary-error-red",
    "--secondary-orange",
    "--secondary-tf-purple",
    "--secondary-lime",
] as const;
export const SVGIconHoverAnimations = [
    null,
    "rotate180",
    "rotate180reverse",
    "up10",
    "down10",
    "left10",
    "right10",
] as const;

// export const OnClickEvent = MouseEventHandler |  (e) => void as const


